import React, { useState, useEffect, useRef } from 'react';
import styles from './faqsData.module.css';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const faqsData = [
  {
    question: "What is ToxBox?",
    answer: "ToxBox is an AI-powered voice assistant designed to handle customer calls, answer inquiries, book appointments, and provide support 24/7, simulating human-like conversations for seamless customer experiences."
  },
  {
    question: "What are the benefits of using ToxBox?",
    answer: "ToxBox optimizes costs by automating routine tasks, provides 24/7 availability for faster responses, reduces human error, boosts customer satisfaction, and can increase sales through personalized recommendations and lead nurturing."
  },
  {
    question: "Can I customize ToxBox for my business?",
    answer: "Yes, ToxBox offers flexible customization including voice and tone matching your brand, integration with existing systems, and tailored workflows to fit specific industry needs."
  },
  {
    question: "What industries can use ToxBox?",
    answer: "ToxBox is versatile and suitable for industries such as healthcare, retail, e-commerce, hospitality, fintech, and customer support, where handling high volumes of inquiries is essential."
  },
  {
    question: "Does ToxBox require coding knowledge to set up?",
    answer: "No, ToxBox features an intuitive setup process with drag-and-drop builders and pre-built templates, making it accessible without any coding expertise."
  },
  {
    question: "Is there a free trial available?",
    answer: "Yes, we offer a free trial period to let you test ToxBox's features and see how it enhances your customer service operations."
  }
];

const FAQComponent = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqItemsRef = useRef([]);

  useEffect(() => {
    // Register GSAP ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Animate FAQ items when they enter the viewport
    faqItemsRef.current.forEach((el, index) => {
      if (el) {
        gsap.fromTo(
          el,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              toggleActions: 'play none none reverse',
            },
          }
        );
      }
    });

    // Cleanup: Kill ScrollTriggers on unmount
    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  useEffect(() => {
    // Animate answer expansion/collapse
    faqItemsRef.current.forEach((el, index) => {
      if (el) {
        const answer = el.getElementsByClassName(styles.answer)[0]; // Use getElementsByClassName to avoid invalid selector issues
        if (answer) {
          if (activeIndex === index) {
            gsap.fromTo(
              answer,
              { height: 0, opacity: 0 },
              { height: 'auto', opacity: 1, duration: 0.5, ease: 'power2.out' }
            );
          } else {
            gsap.to(answer, { height: 0, opacity: 0, duration: 0.3, ease: 'power2.in' });
          }
        }
      }
    });
  }, [activeIndex]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={styles.container}>
      <h2>Frequently Asked Question <span className={styles.highlight}>( FAQ’s )</span></h2>
      
      {faqsData.map((faq, index) => (
        <div
          key={index}
          className={styles.faqItem}
          ref={(el) => (faqItemsRef.current[index] = el)}
        >
          <div
            className={styles.question}
            onClick={() => toggleFAQ(index)}
          >
            {faq.question}
            <span className={styles.icon}>
              {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          {activeIndex === index && <div className={styles.answer}>{faq.answer}</div>}
        </div>
      ))}
    </div>
  );
};

export default FAQComponent;